import Login from '@pages/Login';
import ResetPassword from '@pages/ResetPassword';
// import Terminos from '@pages/Terminos';
// import FAQ from '@pages/FAQ';
// import Refrescar from '@pages/Refrescar';

const PUBLIC_ROUTES = [
  {
    path: '/iniciar-sesion',
    key: 'LOGIN',
    exact: true,
    component: Login,
  },
  {
    path: '/assing-password/:token',
    key: 'RESET_PASSWORD',
    exact: true,
    component: ResetPassword,
  },
  // {
  //   path: '/terminos-condiciones',
  //   key: 'TERMINOS',
  //   exact: true,
  //   component: Terminos,
  // },
  // {
  //   path: '/faq',
  //   key: 'FAQ',
  //   exact: true,
  //   component: FAQ,
  // },
  // {
  //   path: '/refrescar',
  //   key: 'REFRESH',
  //   exact: true,
  //   component: Refrescar,
  // },
];

export default PUBLIC_ROUTES;
